"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function CulinaryHub() {
  const {
    ref: sectionRef,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const photos = [{
    src: "https://balanced-whippet.10web.cloud/wp-content/uploads/2026/07/ChatGPT-Image-Jul-3-2026-11_33_45-AM-2-1.png?v=bzxcus6oh1w",
    srcset: "https://balanced-whippet.10web.cloud/wp-content/uploads/2026/07/ChatGPT-Image-Jul-3-2026-11_33_45-AM-2-1.png?v=fpc5zktolea-wvc-srcset",
    sizes: "https://balanced-whippet.10web.cloud/wp-content/uploads/2026/07/ChatGPT-Image-Jul-3-2026-11_33_45-AM-2-1.png?v=4f9hticsz9f-wvc-sizes",
    alt: "Professional ProWhip cream chargers arranged on a clean kitchen surface",
    ratio: "aspect-square",
    withCoin: true
  }, {
    src: "https://balanced-whippet.10web.cloud/wp-content/uploads/2026/07/ChatGPT-Image-Jul-3-2026-11_33_47-AM-4.png?v=299468tsrtu",
    srcset: "https://balanced-whippet.10web.cloud/wp-content/uploads/2026/07/ChatGPT-Image-Jul-3-2026-11_33_47-AM-4.png?v=xdxl55j730d-wvc-srcset",
    sizes: "https://balanced-whippet.10web.cloud/wp-content/uploads/2026/07/ChatGPT-Image-Jul-3-2026-11_33_47-AM-4.png?v=ddpbmd7hjo-wvc-sizes",
    alt: "Close-up of high-quality culinary tools and ProWhip equipment",
    ratio: "aspect-square",
    withCoin: false
  }, {
    src: "https://balanced-whippet.10web.cloud/wp-content/uploads/2026/07/ChatGPT-Image-Jul-3-2026-11_36_13-AM-1.png?v=lce6c4d6wib",
    srcset: "https://balanced-whippet.10web.cloud/wp-content/uploads/2026/07/ChatGPT-Image-Jul-3-2026-11_36_13-AM-1.png?v=haxu2z0wbm6-wvc-srcset",
    sizes: "https://balanced-whippet.10web.cloud/wp-content/uploads/2026/07/ChatGPT-Image-Jul-3-2026-11_36_13-AM-1.png?v=on0tmkp9okq-wvc-sizes",
    alt: "Modern professional kitchen environment showcasing ProWhip products",
    ratio: "aspect-square",
    withCoin: false
  }];
  const paragraphs = ["ProWhip provides professional-grade culinary tools designed for precision and reliability in every kitchen.", "We support chefs and home enthusiasts with high-quality equipment that ensures consistent results for every creation.", "Our mission is to be your trusted partner in the kitchen, offering the best tools to help you push your culinary boundaries."];
  return <section data-section-id="1495" id="culinary-creativity-hub" ref={sectionRef} className="bg-background text-foreground relative overflow-hidden py-16 md:py-20">
      {}
      <svg aria-hidden="true" className="pointer-events-none absolute -top-12 -right-16 h-72 w-72 opacity-65 md:h-96 md:w-96" viewBox="0 0 400 400" fill="none">
        <g stroke="var(--border)" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" fill="none">
          <path d="M380 20 Q260 80 180 200 Q140 260 110 340" />
          <path d="M360 30 Q330 50 310 80" />
          <path d="M340 60 Q300 80 270 110" />
          <path d="M320 100 Q280 130 240 160" />
          <path d="M290 140 Q250 170 210 200" />
          <path d="M260 180 Q220 210 180 240" />
          <path d="M230 220 Q190 250 150 280" />
          <path d="M200 260 Q165 290 130 320" />
          <path d="M170 300 Q140 325 115 345" />
        </g>
      </svg>

      {}
      <svg aria-hidden="true" className="pointer-events-none absolute -bottom-16 -left-12 h-72 w-72 opacity-65 md:h-96 md:w-96" viewBox="0 0 400 400" fill="none">
        <g stroke="var(--border)" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" fill="none">
          <path d="M20 380 Q140 320 220 200 Q260 140 290 60" />
          <path d="M40 360 Q70 340 95 315" />
          <path d="M60 330 Q100 305 130 280" />
          <path d="M85 295 Q125 265 165 235" />
          <path d="M115 260 Q155 230 195 200" />
          <path d="M145 225 Q185 195 220 165" />
          <path d="M175 190 Q215 160 250 130" />
          <path d="M205 155 Q235 130 265 105" />
          <path d="M235 120 Q260 95 285 75" />
        </g>
      </svg>

      <div className="relative mx-auto max-w-[1320px] px-6 md:px-8">
        <div className="grid grid-cols-1 gap-12 lg:grid-cols-12 lg:gap-14" style={{
        opacity: isVisible ? 1 : 0,
        transform: isVisible ? "translateY(0)" : "translateY(16px)",
        transition: "opacity 640ms cubic-bezier(0.22, 1, 0.36, 1), transform 640ms cubic-bezier(0.22, 1, 0.36, 1)"
      }}>
          {}
          <div className="lg:col-span-7">
            {}
            

            {}
            <h2 className="mt-6 font-default font-bold leading-[1.06] tracking-[-0.02em] text-foreground" style={{
            fontSize: "clamp(2rem, 4.4vw, 3.75rem)"
          }}>
              Precision in{" "}
              <span className="font-default italic text-primary" style={{
              display: "inline-block",
              clipPath: isVisible ? "inset(0 0 0 0)" : "inset(0 100% 0 0)",
              transition: "clip-path 720ms cubic-bezier(0.22, 1, 0.36, 1) 200ms"
            }}>
                pressure
              </span>
              , for every chef.
            </h2>

            {}
            

            {}
            <blockquote className="my-8">
              <p className="font-default italic text-primary leading-[1.3]" style={{
              fontSize: "1.5rem"
            }}>''Premium&nbsp;Quality"</p>
            </blockquote>

            {}
            <div className="mb-6 flex items-center gap-2" aria-hidden="true">
              <span className="inline-block h-1.5 w-1.5 rounded-lg bg-primary" />
              <span className="h-px flex-1" style={{
              backgroundImage: "repeating-linear-gradient(to right, var(--foreground) 0 6px, transparent 6px 11px)",
              opacity: 0.6
            }} />
            </div>

            {}
            <p className="font-default text-sm font-medium tracking-[0.02em] text-muted-foreground">
              At Pro-Whip, we supply premium whip cream infusion products designed to bring professional quality and creative freedom into every kitchen. Our whip cream infusers make it simple to create fresh whipped cream, flavoured creams, dessert toppings, mousses, foams, sauces, cocktails, coffees, and other culinary finishes with smooth, consistent results. Whether used by chefs, bakers, baristas, caterers, or home creators, Pro-Whip offers a reliable and versatile way to elevate desserts, drinks, and dishes with ease.
            </p>
          </div>

          {}
          <div className="lg:col-span-5">
            <div className="lg:sticky lg:top-24">
              {}
              <div className="flex gap-4 overflow-x-auto pb-4 lg:hidden -mx-6 px-6 snap-x snap-mandatory">
                {photos.map((photo, i) => <div key={i} data-index={i} className="relative shrink-0 w-[78%] snap-start">
                    {photo.withCoin && <div aria-hidden="true" className="absolute -top-6 -left-6 z-0 rounded-lg" style={{
                  width: "180px",
                  height: "180px",
                  backgroundColor: "var(--primary)",
                  borderRadius: "8px",
                  opacity: 0.85
                }} />}
                    <div className={`relative z-10 overflow-hidden ${photo.ratio}`} style={{
                  borderRadius: "8px"
                }}>
                      <img src={photo.src} data-wvc-srcset={photo.srcset} data-wvc-sizes={photo.sizes} alt={photo.alt} loading="lazy" decoding="async" className="h-full w-full object-cover" />
                    </div>
                  </div>)}
              </div>

              {}
              <div className="hidden lg:grid lg:grid-cols-2 lg:gap-6 relative">
                {photos.map((photo, i) => <div key={i} data-index={i} className="relative">
                    {}
                    {photo.withCoin && <div aria-hidden="true" className="absolute z-0" style={{
                  width: "80px",
                  height: "80px",
                  backgroundColor: "var(--primary)",
                  borderRadius: "8px",
                  opacity: 0.85,
                  top: "-12px",
                  right: "-12px"
                }} />}
                    <div className={`relative z-10 overflow-hidden ${photo.ratio}`} style={{
                  borderRadius: "8px"
                }}>
                      <img src={photo.src} data-wvc-srcset={photo.srcset} data-wvc-sizes={photo.sizes} alt={photo.alt} loading="lazy" decoding="async" className="h-full w-full object-cover" />
                    </div>
                  </div>)}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}